import { render, staticRenderFns } from "./UsersFunnel.vue?vue&type=template&id=4980d654"
import script from "./UsersFunnel.vue?vue&type=script&lang=js"
export * from "./UsersFunnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports